import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import img1 from "../../assets/Soft/11 aug 2ndArtboard 31.png";
import img2 from "../../assets/Soft/11 aug 2ndArtboard 1.png";
import img3 from "../../assets/Soft/28-7-25Artboard 2 1.png";
import img4 from "../../assets/Soft/21-7-25Artboard 1 2.png";
import img5 from "../../assets/Soft/Free copy 1.png";

const NewPortfolioSoft = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-6 sm:px-10 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <section
        className={`relative mx-auto py-5 md:py-0 transition-all duration-500 max-w-[1536px]`}
      >
        {/* Header Section */}
        <div className="flex flex-col justify-center items-center text-center">
          <h2
            className={`bricolage-grotesque-bold font-semibold px-4 py-1 sm:py-2 rounded-full md:mb-2 transition-all duration-500 ${
              theme === "dark"
                ? "bg-[#d9d9d9] text-black"
                : "bg-[#232323] text-white"
            } text-[18px] sm:text-[22px] md:text-[28px] lg:text-[32px]`}
          >
            Softside
          </h2>

          <h3
            className={`uppercase bricolage-grotesque-semibold font-bold transition-all duration-500 ${
              theme === "dark" ? "text-gray-800" : "text-white"
            } text-[14px] sm:text-[18px] md:text-[22px] lg:text-[24px]`}
          >
            A Bathtub Cushion
          </h3>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full md:py-10">
          <img src={img1} alt="Soft Design 1" className="w-full" />
          <img src={img2} alt="Soft Design 2" className="w-full" />
          <img src={img3} alt="Soft Design 3" className="w-full" />
          <img src={img4} alt="Soft Design 4" className="w-full" />
        </div>

        {/* Featured Image Section */}
        <div className="flex justify-center w-full md:py-10 mt-3 sm:mt-14 md:mt-16">
          <img
            src={img5}
            alt="Softside Main"
            className="w-full object-cover shadow-[0_-30px_60px_-10px_rgba(141,25,218,0.5),0_30px_60px_-10px_rgba(141,25,218,0.5),0_0_25px_-5px_rgba(141,25,218,0.4)] md:shadow-[0_-60px_120px_-20px_rgba(141,25,218,1),0_60px_120px_-20px_rgba(141,25,218,1),0_0_50px_-10px_rgba(141,25,218,0.6)]"
          />
        </div>
      </section>
    </div>
  );
};

export default NewPortfolioSoft;
